import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getAdditionalFieldValues as getAdditionalFieldValuesAPI} from '../../../services/groups'

export async function getAdditionalFieldValues(
  dispatch,
  group_id,
  field_types,
  include_actions,
  include_related,
  currency_items
) {
  try {
    dispatch({type: PENDING})
    let response = await getAdditionalFieldValuesAPI(
      group_id,
      field_types,
      include_actions,
      include_related,
      currency_items
    )

    dispatch({type: SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Group Filters Failed: ${group_id}`)
    dispatch({type: FAILURE, payload: e})
  }
}
